<div class="k-overlay" *ngIf="dialogSearchDirectoryOpened"></div>
<kendo-window *ngIf="dialogSearchDirectoryOpened" (close)="closeSearch(true)" [width]="1200"
    (keydown)="modalKeyDown($event)" [state]="windowState" class="kendo-window">
    <kendo-window-titlebar>
        <div class="k-window-title">
            <h3 class="ellipsis-text">{{ 'DIRECTORY-SEARCH-CHANNELS' | translate }}</h3>
        </div>
        <button kendoWindowMaximizeAction></button>
        <!--Hiding restore because modal show behind and unable to resolve 
        <button kendoWindowRestoreAction></button>-->
        <button kendoWindowCloseAction></button>
    </kendo-window-titlebar>
    <app-provider-search [allowSelection]="allowSelection" [allowFacilitySearch]="allowFacilitySearch"
        [memberId]="memberId" [singleSelectionOnly]="singleSelectionOnly" (selectProvider)="onSetProviders($event)">
    </app-provider-search>
    <kendo-dialog-actions class="mt-2">
        <button class="k-button" (click)="closeSearch(true)">{{ allowSelection ? 'CANCEL' : 'CLOSE' | translate }}
        </button>
        <button *ngIf="allowSelection" kendoButton [primary]="true" (click)="onSelectedProviders()"
            style="margin-right: -10px;" type="button" class="far fa-check" [disabled]="getSelectedCount() === 0">
            {{ 'SELECT' | translate }} <span *ngIf="getSelectedCount() > 0">({{getSelectedCount()}})</span>
        </button>
    </kendo-dialog-actions>
</kendo-window>